<template>
  <t-header class="tournaments-page-header">
    <c-belote-header v-if="zoneTrimmed === TournamentTypeToName[TOURNAMENT_TYPE.BEL_TOURNAMENT]" />
    <c-romme-header v-if="zoneTrimmed === TournamentTypeToName[TOURNAMENT_TYPE.ROM_TOURNAMENT]" :language="language" />
    <c-romme-masters-header v-if="zoneTrimmed === TournamentTypeToName[TOURNAMENT_TYPE.ROM_MASTERS]" />
    <c-skat-header v-if="zoneTrimmed === TournamentTypeToName[TOURNAMENT_TYPE.SKA_TOURNAMENT]" />
    <c-skat-masters-header v-if="zoneTrimmed === TournamentTypeToName[TOURNAMENT_TYPE.SKA_MASTERS]" />
  </t-header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { TournamentTypeToName, TOURNAMENT_TYPE } from '@/model/TournamentType'
import CBeloteHeader from '@/components/headers/CBeloteHeader.vue'
import CRommeHeader from '@/components/headers/CRommeHeader.vue'
import CRommeMastersHeader from '@/components/headers/CRommeMastersHeader.vue'
import CSkatHeader from '@/components/headers/CSkatHeader.vue'
import CSkatMastersHeader from '@/components/headers/CSkatMastersHeader.vue'
const props = withDefaults(defineProps<{ zone: string; language: string }>(), { zone: '', language: 'en' })
const zoneTrimmed = computed(() => {
  return props.zone.replace('_gd', '')
})
</script>

<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';

.tournaments-page-header {
  position: relative;
  z-index: 1;
  .outer {
    height: 100%;
    width: 100%;
  }

  .inner {
    display: flex;
    position: relative;
    margin: 0 auto;
    max-width: 940px;
    height: 100%;
    &.front {
      transform: translateY(-100%);
    }
  }

  .shadow {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-width: 0;
    &.masters {
      border-bottom: 3px solid;
      border-image: linear-gradient(
          to right,
          rgba(113, 83, 13, 1) 0%,
          rgba(240, 235, 157, 1) 45%,
          rgba(113, 83, 13, 1) 120%
        )
        0 0 100%;
      box-shadow: 0 0.35em 0.5em -0.3em rgba(0, 0, 0, 0.35);
    }
  }
}
</style>
